import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import * as Yup from 'yup'
import { ArticleContainer } from '_core/components/ArticleContainer'

// @material-ui
import { Typography, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { withLang } from '_core/hocs/withLang'
import { TextInput } from '_core/components/TextInput'
import { FormValidator } from '_core/components/FormValidator'

// style
import { verifyEmailStepCountStyle } from './verifyEmailStepCountStyle'

const RawVerifyEmailStepCount = props => {
  const { classes, time, update, getLangString: l } = props

  const {
    request: { queue },
    config: { API_METHOD, VERIFICATION_TYPE },
  } = useGlobal()

  const [values, setValues] = useState({})
  const [duration, setDuration] = useState(
    moment.duration(Math.floor(time), 'seconds')
  )

  useEffect(() => {
    const id = setInterval(() => {
      setDuration(
        moment.duration(duration.subtract(1, 'seconds').asMilliseconds())
      )
    }, 1000)

    return () => clearInterval(id)
  }, [])

  if (duration.asMilliseconds() <= 0) {
    update()
  }

  const getOnChange = field => value => {
    setValues(oldValues => ({
      ...oldValues,
      [field]: value,
    }))
  }

  const onSubmit = async event => {
    event.preventDefault()

    queue(API_METHOD.VISITOR_VERIFICATION_CHECK, { type: VERIFICATION_TYPE.EMAIL, ...values })
      .then((data) => update());
  }

  const fields = {
    code: {
      value: values['code'],
      label: l('r._.profile.verify.email.label.code'),
      onChange: getOnChange('code'),
      ban: /[^0-9]/g,
      shape: Yup.string(l('r._.profile.verify.email.label.code'))
        .trim()
        .ensure()
        .required('empty')
        .length(6, 'bad'),
    },
  }

  return (
    <form onSubmit={onSubmit} className={classes.root}>
      <Typography variant="body2">
        <ArticleContainer variant="body2" className={classes.infotext}>
          {l('r._.profile.verify.email.text.countertitle')}
        </ArticleContainer>
      </Typography>
      <Typography variant="caption" gutterBottom={true}>
        {duration.minutes() === 0
          ? l('r._.profile.verify.mobile.text.countersec', duration.seconds())
          : l(
              'r._.profile.verify.mobile.text.counterminsec',
              duration.minutes(),
              duration.seconds()
            )}
      </Typography>

      <FormValidator
        fields={fields}
        render={({ form, canSubmit }) => (
          <Grid container={true}>
            <Grid item={true} xs={12} sm={8}>
              <TextInput {...form['code']} />
            </Grid>

            <Grid item={true} xs={12} sm={4}>
              <Button type="submit" fullWidth={true} disabled={!canSubmit}>
                {l('r._.profile.verify.control.submit')}
              </Button>
            </Grid>
          </Grid>
        )}
      />
    </form>
  )
}

RawVerifyEmailStepCount.defaultProps = {
  time: 60,
}

RawVerifyEmailStepCount.propTypes = {
  // self props
  time: PropTypes.string.isRequired,
  update: PropTypes.func.isRequired,

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const VerifyEmailStepCount = withLang(
  withStyles(verifyEmailStepCountStyle)(RawVerifyEmailStepCount)
)
